import { HOST, TENANTS_NAMES } from './host_config';
import xpo from './configs_by_tenant/xpo';
import intraser from './configs_by_tenant/intraser';
import ontruck from './configs_by_tenant/ontruck';
import acme from './configs_by_tenant/acme';
import rpt from './configs_by_tenant/rpt';
import cex from './configs_by_tenant/cex';
import ontime from './configs_by_tenant/ontime';
import alianza from './configs_by_tenant/alianza';
export const getTenantPreLoginConfig = () => {
  const tenantConfig = {
    [TENANTS_NAMES.intraser]: intraser,
    [TENANTS_NAMES.xpo]: xpo,
    [TENANTS_NAMES.ontruck]: ontruck,
    [TENANTS_NAMES.acme]: acme,
    [TENANTS_NAMES.rpt]: rpt,
    [TENANTS_NAMES.cex]: cex,
    [TENANTS_NAMES.ontime]: ontime,
    [TENANTS_NAMES.alianza]: alianza,
  };
  return { ...tenantConfig[HOST] };
};
